import { motion } from "framer-motion";
const Promotion = () => {
  const filieres = [
    {
      title: "MENUISERIE BOIS",
      image: "/images/filier-bois.webp",
      items: [
        "Le mobilier scolaire",
        "Le mobilier hospitalier",
        "Le mobilier bureau",
        "Le cahier de menuiserie des constructions",
        "L'équipement des salles de conférences en tables et chaises"
      ]
    },
    {
      title: "TEXTILE",
      image: "/images/filier-textil.webp",
      items: [
        "Des tenues militaires et civiles (élèves et travailleurs)",
        "Les blouses médicales",
        "L'uniforme des détenus",
        "Les tenues scolaires"
      ]
    },
    {
      title: "CUIRS ET PEAUX",
      image: "/images/filier-cuire.webp",
      items: [
        "Ceintures et étuis pour armée, police et gendarmerie",
        "Selles, harnais et bottes en cuir pour la cavalerie"
      ]
    },
    {
      title: "MENUISERIE MÉTALLIQUE",
      image: "/images/filier-metallique.webp",
      items: [
        "Batteuse à mil et à riz",
        "Décortiqueuse à riz",
        "Semoirs etc.",
        "La menuiserie métallique et le fer forgé",
        "Fabrication d'éléments métalliques pour la construction",
        "Réparation et entretien des équipements agricoles",
        "Conception de structures métal. pour bâtiments publics"
      ]
    },
    {
      title: "MÉCANIQUE AUTOMOBILE",
      image: "/images/filier-mecanique.webp",
      items: [
        "Maintenance et réparation du parc automobile de l'Etat",
        "Ouverture de la Zone d'Activités des Mécaniciens (ZAMPA)",
        "Fabrication locale de pièces et accessoires automobiles",
        "Formation des jeunes aux métiers de la mécanique automobile",
        "Création d'un système centralisé pour la gestion des ateliers"
      ]
    },
    {
      title: "BTP",
      image: "/images/filier-bpt.webp",
      items: [
        "Construction de bâtiments publics et communautaires",
        "Réhabilitation de bâtiments administratifs anciens",
        "Aménagement d’espaces artisanaux et commerciaux",
        "Construction de hangars, marchés et ateliers ruraux",
        "Réalisation d’infrastructures pour services sociaux"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#1E3D1A]">
        <div className="absolute inset-0 bg-[url('/filere-artisanales.webp')] opacity-50" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-8 tracking-wider">
            FILIÈRES ARTISANALES
            </h1>
            <p className="text-xl text-white/90">
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filieres.map((filiere, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="relative h-48">
                  <img
                    src={filiere.image}
                    alt={filiere.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 flex items-center space-x-2">
                    <div className="bg-[#1E3D1A] p-2 rounded-lg text-white">
                      
                    </div>
                    <h3 className="text-xl font-bold text-white">
                      {filiere.title}
                    </h3>
                  </div>
                </div>
                <div className="p-6">
                  <ul className="space-y-3">
                    {filiere.items.map((item, i) => (
                      <motion.li
                        key={i}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3, delay: i * 0.1 }}
                        className="flex items-start space-x-3"
                      >
                        <div className="w-2 h-2 rounded-full bg-[#1E3D1A] mt-2" />
                        <span className="text-gray-600 leading-relaxed">
                          {item}
                        </span>
                      </motion.li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Promotion;
